module.exports = __webpack_public_path__ + "media/img/masks/avatar-group-936a2d3aedfe174ffaf564808de152fe.svg";